import fetch from "../../uilts/request.js";


export default {
    createBoolTemp(data) {
        return fetch.post('/BigData/createBoolTemp', data)
    },
    previewFileId3(data) {
        return fetch.post('/BigData/previewFileId3', data)
    },
    downFileId3(data) {
        return fetch.post('/BigData/downFileId3', data)
    },
    createZuWuTemp(data) {
        return fetch.post('/BigData/createZuWuTemp', data)
    },
    previewFileId22(data) {
        return fetch.post('/BigData/previewFileId22', data)
    },
    downFileId22(data) {
        return fetch.post('/BigData/downFileId22', data)
    },
    queryZuWu(data) {
        return fetch.post('/BigData/queryZuWu', data)
    },
    queryBoole(data) {
        return fetch.post('/BigData/queryBoole', data)
    },
    gaoJi(data) {
        return fetch.post('/BigData/gaoJi', data)
    }


}
